
export enum EAppEnvironment {
    development,
    production
}